// extracted by mini-css-extract-plugin
module.exports = {"landing_banner":"LandingPageBanner_landing_banner__3FRPb","group_coaching":"LandingPageBanner_group_coaching__2Jii7","portrait":"LandingPageBanner_portrait__2T5fK"};